import { atom } from 'nanostores';

export const verificationReplyMark = atom<Date | null>(null);

export const verificationStepWasShown = atom(false);
